import { getCookie, setCookie } from 'cookies-next';

const COOKIE_NAME = 'ido.attribution';
// 30 dias — janela de atribuição "último clique" até ao checkout, o mesmo
// prazo que o Google Ads usa por omissão para anúncios de Shopping/PMAX.
const MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

const ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
] as const;

export type Attribution = Partial<Record<(typeof ATTRIBUTION_KEYS)[number], string>>;

/**
 * Lê os parâmetros de campanha do URL atual (utm_*, gclid, fbclid — Google
 * Ads e Meta Ads) e grava-os num cookie que sobrevive à navegação pelo
 * site, para se saber de onde veio o cliente mesmo que o checkout só
 * aconteça dias depois e várias páginas adiante.
 *
 * Só regrava o cookie quando o URL traz pelo menos um destes parâmetros —
 * uma visita direta a outra página não apaga a campanha que trouxe o
 * cliente a uma visita anterior (último clique de anúncio, não última
 * página vista).
 */
export function captureAttribution(): void {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const found: Attribution = {};
  ATTRIBUTION_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) found[key] = value.slice(0, 200);
  });

  if (Object.keys(found).length === 0) return;

  try {
    setCookie(COOKIE_NAME, JSON.stringify(found), {
      maxAge: MAX_AGE_SECONDS,
      path: '/',
    });
  } catch {
    // Falha silenciosa (cookies bloqueados) — sem isto, só não há atribuição.
  }
}

export function getStoredAttribution(): Attribution {
  try {
    const raw = getCookie(COOKIE_NAME) as string | undefined;
    if (!raw) return {};
    return JSON.parse(raw) as Attribution;
  } catch {
    return {};
  }
}
